import React from 'react';
import About from './About';
import Contact from './Contact';
import Faq from './Faq';
import Footer from './Footer';
import Header from './Header';
import Hero from './Hero';
import Newsletter from './Newsletter';
import Portfolio from './Portfolio';
import Service from './Service';
import Team from './Team';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Service />
      <Portfolio />
      <Faq />
      <Team />
      <Contact />
      <Newsletter />
      <Footer />
    </>
  )
}

export default Home
